import { App, createApp, h } from 'vue'
import Button from 'objects/button/Button.vue'
import domUtils from 'util/dom-utils'
import Icon from 'objects/icon/Icon.vue'
import log from 'util/logger'
import msg from 'services/msg'

export function createAndMountInstance(
  existingInstance: App,
  widget: unknown, // DefineComponent not enough by iteself, so using unknown
  divId: string,
  props: { [key: string]: unknown } = {}
): Promise<App> {
  return new Promise((resolve) => {
    if (existingInstance) {
      existingInstance.unmount()
    }
    // if the dom element already exists, no need to wait for dom ready
    if (document.getElementById(divId)) {
      resolve(createInstance(widget, divId, props))
      return
    }
    domUtils.onDomReady().then(() => {
      if (document.getElementById(divId)) {
        resolve(createInstance(widget, divId, props))
        return
      }
      log.warn(`Widget not loaded at dom ready. Could not find div with id ${divId}. Trying again shortly...`)
      setTimeout(() => {
        if (document.getElementById(divId)) {
          resolve(createInstance(widget, divId, props))
          return
        }
        log.warn(`Still unable to find widget div with id ${divId}`)
        resolve(null)
      }, 50)
    })
  })
}

function createInstance(widget, divId: string, props): App {
  return createAndMountApp({
    render: () => h(widget, {
      id: divId,
      ...props
    })
  }, divId)
}

/**
 * Creates a Vue App and adds the global components and properties
 *
 * @param componentConfig - object representation
 * @param divId - divId to mount the instance to
 * @param el - alternatvie to divId, the actual element to mount the instance to
 */
export function createAndMountApp(
  componentConfig: unknown, divId: string, el: Element = null
): App {
  const app = createApp(componentConfig)
  // makes these available to all Vue components
  app.component('tt-button', Button)
  app.component('tt-icon', Icon)
  app.config.globalProperties.$msg = msg
  if (divId) {
    app.mount(`#${divId}`)
  } else {
    app.mount(el)
  }
  return app
}
